import { isProd } from './api'

export const ybiConfig = (() => {
  let config
  if (isProd) {
    config = {
      apiKey: '5394/213bcc17f77c752b5644fec69cb4f1ac9f9ef406',
      database: 'datamart_uranaitv',
      tablePlayMovie: 'play_movie',
      tablePlayVod: 'play_vod',
      tableDataBloadcast: 'data_broadcast_logs',
      tablePlayAd: 'vod_ads',
      enviroment: 'production'
    }
  } else {
    config = {
      apiKey: '5394/213bcc17f77c752b5644fec69cb4f1ac9f9ef406',
      database: 'datamart_uranaitv',
      tablePlayMovie: 'play_movie_web',
      tablePlayVod: 'play_vod_web',
      tableDataBloadcast: 'data_broadcast_logs_test',
      tablePlayAd: 'vod_ads_test',
      enviroment: 'sandbox'
    }
  }
  return config
})()



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/VideoPlayer/utils/ybiConfig.js